(function(window) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.events = (function() {
      // external smart player events (value casing matters to maintain backward capability)
      var _videoStartInitiated = 'VIDEO_START_INITIATED';
      var _videoStart = 'VIDEO_START';
      var _mediaReady = 'MEDIA_READY';
      var _captionChange = 'CAPTION_CHANGE';
      var _ready = 'READY';
      var _videoPlay = 'VIDEO_PLAY';
      var _playerFullScreenModeChanged = 'PLAYER_FULL_SCREEN_MODE_CHANGED';
      var _playerRumData = 'PLAYER_RUM_DATA';

      // Control Events
      var _clickPrevControl = 'tscspClickPrevControl';
      var _clickNextControl = 'tscspClickNextControl';
      var _fullScreenChange = 'tscspFullScreenChange';
      var _expandVideo = 'tscspExpandVideo';
      var _clickLoadAndPlayControl = 'tscspClickLoadAndPlayControl';
      var _clickPlayControl = 'tscspClickPlayControl';
      var _showToc = 'tscspShowToc';
      var _hideToc = 'tscspHideToc';
      var _disableControls = 'tscspDisableControls';
      var _enableControls = 'tscspEnableControls';
      var _controlsUpdated = 'tscspControlsUpdated';
      var _pipChanged = 'tscspPipChange';

      // Media Element Events
      var _playMedia = 'play';
      var _pauseMedia = 'pause';
      var _seekMediaToTime = 'tscspSeekMediaToTime';
      var _replayMedia = 'tscspReplayMedia';
      var _endMedia = 'tscspEndMedia';

      // IFrame Events
      var _enterFullFrame = 'ENTER-FULLFRAME';
      var _exitFullFrame = 'EXIT-FULLFRAME';

      // Update Events
      var _updateQuizMarkers = 'tscspUpdateQuizMarkers';
      var _updatePlayProgress = 'tscspUpdatePlayProgress';
      var _updateLoadProgress = 'tscspUpdateLoadProgress';
      var _updateNextQuestionPos = 'tscspUpdateNextQuestionXPos';

      // Scrubbing Events
      var _startedScrubbing = 'tscspStartedScrubbing';
      var _endedScrubbing = 'tscspEndedScrubbing';

      // Quiz Events
      var _quizPaused = 'tscspMediaPaused';
      var _quizComplete = 'tscspQuizComplete';
      var _quizReview = 'tscspQuizReview';
      var _quizBegin = 'tscspQuizBegin';
      var _quizBeginClicked = 'tscspQuizBeginClicked';
      var _quizSkip = 'tscspQuizSkip';
      var _quizSkipClicked = 'tscspSkipQuizClicked';
      var _quizError = 'tscspQuizError';
      var _quizStatus = 'tscspQuizStatus';
      var _quizSubmittingInstance = 'tscspSubmittingInstance';
      var _quizSubmitted = 'tscspQuizSubmitted';
      var _quizShowSubmissionRetryMessage = 'tscspQuizShowSubmissionRetryMessage';
      var _quizHideSubmissionRetryMessage = 'tscspQuizHideSubmissionRetryMessage';
      var _quizHideLoadingMessage = 'tscspQuizHideLoadingMessage';
      var _transitionImageQuizToAnswers = 'tscspTransitionImageQuizToAnswers';
      var _hideQuiz = 'tscspHideQuiz';
      var _showQuizBar = 'tscspShowQuizBar';
      var _closeQuestionSetView = 'tscspCloseQuestionSetView';
      var _submitQuestionSet = 'tscspSubmitQuestionSet';
      var _rationaleActionLocation = 'tscspRationaleActionLocation';
      var _rationaleActionJumpToTime = 'tscspRationaleActionJumpToTime';
      var _quizIsOutOfDate = 'tscspQuizIsOutOfDate';

      //Captions
      var _captionsChanged = 'tscspCaptionChanged';
      var _captionsLanguageChanged = 'tscspLanguageChanged';

      // Audio Description
      var _audioDescriptionChanged = 'tscspAudioDescriptionChanged';
      var _audioDescriptionFailed = 'tscspAudioDescriptionFailed';

      //Hotspots
      var _hotspotPaused = 'tscspHotspotPaused';
      var _hotspotResume = 'tscspHotspotResume';
      var _hotspotClicked = 'tscspHotspotClicked';
      var _hotspotAreaActive = 'tscspHotspotAreaActive';
      var _hotspotAreaInactive = 'tscspHotspotAreaInactive';

      //Timing
      var _smartPlayerInitialized = 'smart_player_initialized';
      var _smartPlayerLoaded = 'smart_player_loaded';
      var _videoMetadataLoaded = 'video_metadata_loaded';
      var _videoLoadeData = 'video_loaded_data';
      var _videoCanPlay = 'video_can_play';

      //Plugins
      var _pluginAdded = 'pluginAdded';

      return Object.freeze({
         External: {
            VideoStartInitiated: _videoStartInitiated,
            VideoStart: _videoStart,
            MediaReady: _mediaReady,
            CaptionChange: _captionChange,
            Ready: _ready,
            VideoPlay: _videoPlay,
            PlayerFullScreenModeChanged: _playerFullScreenModeChanged,
            PlayerRumData: _playerRumData
         },
         Controls: {
            ClickPrev: _clickPrevControl,
            ClickNext: _clickNextControl,
            FullScreenChange: _fullScreenChange,
            ExpandVideo: _expandVideo,
            LoadAndPlayControl: _clickLoadAndPlayControl,
            PlayControl: _clickPlayControl,
            ShowToc: _showToc,
            HideToc: _hideToc,
            Disable: _disableControls,
            Enable: _enableControls,
            Updated: _controlsUpdated,
            HotspotClicked: _hotspotClicked,
            PipChanged: _pipChanged
         },
         Hotspots: {
            Paused: _hotspotPaused,
            Resume: _hotspotResume,
            AreaActive: _hotspotAreaActive,
            AreaInactive: _hotspotAreaInactive
         },
         Media: {
            Play: _playMedia,
            Pause: _pauseMedia,
            SeekToTime: _seekMediaToTime,
            Replay: _replayMedia,
            End: _endMedia
         },
         IFrame: {
            EnterFullFrame: _enterFullFrame,
            ExitFullFrame: _exitFullFrame
         },
         Update: {
            QuizMarkers: _updateQuizMarkers,
            PlayProgress: _updatePlayProgress,
            LoadProgress: _updateLoadProgress,
            NextQuestionPosition: _updateNextQuestionPos
         },
         Scrubbing: {
            Started: _startedScrubbing,
            Ended: _endedScrubbing
         },
         Quizzing: {
            Paused: _quizPaused,
            Complete: _quizComplete,
            Review: _quizReview,
            Begin: _quizBegin,
            BeginClicked: _quizBeginClicked,
            Skip: _quizSkip,
            SkipClicked: _quizSkipClicked,
            Error: _quizError,
            Status: _quizStatus,
            SubmittingInstance: _quizSubmittingInstance,
            Submitted: _quizSubmitted,
            ShowSubmissionRetryMessage: _quizShowSubmissionRetryMessage,
            HideSubmissionRetryMessage: _quizHideSubmissionRetryMessage,
            HideLoadingMessage: _quizHideLoadingMessage,
            TransitionImageQuizToAnswers: _transitionImageQuizToAnswers,
            HideQuiz: _hideQuiz,
            ShowQuizBar: _showQuizBar,
            CloseQuestionSetView: _closeQuestionSetView,
            SubmitQuestionSet: _submitQuestionSet,
            RationaleActionLocation: _rationaleActionLocation,
            RationaleActionJumpToTime: _rationaleActionJumpToTime,
            QuizIsOutOfDate: _quizIsOutOfDate
         },
         Captions: {
            Changed: _captionsChanged,
            LanguageChanged: _captionsLanguageChanged
         },
         AudioDescription: {
            Changed: _audioDescriptionChanged,
            Failed: _audioDescriptionFailed
         },
         Timing: {
            PlayerInitialized: _smartPlayerInitialized,
            PlayerLoaded: _smartPlayerLoaded,
            VideoMetadataLoaded: _videoMetadataLoaded,
            VideoLoadedData: _videoLoadeData,
            VideoCanPlay: _videoCanPlay
         },
         Plugin: {
            Added: _pluginAdded
         }
      });
   }());
}(this));
